import { LicensePlans, LicenseTypes } from "./const";

export enum LicenseFlagsBoolean {
    accessLevelsProjectMemberGranularity = "AccessLevels_ProjectMember_Granularity",
    vacations = "Vacations",
    skills = "Skills",
    /** Forms License Flags**/
    formConditionalQuestions = "FormConditionalQuestions",
    /** Messages Board License Flags **/
    messagesApproval = "Messages_Approval",
    aiMessages = "AIMessages",
    /** Billing License Flags **/
    billingInfo = "BillingInfo",
    billingHourlyRate = "BillingInfo_BillableRate",
    billingRateCard = "BillingInfo_RateCards",
    budgetManagement = "BudgetManagement",
    /** Hours License Flags **/
    hoursManagement = "HoursManagement",
    /** Timelogs License Flags **/
    timelogs = "Timelogs",
    timelogsApproval = "Timelogs_Approval",
    timelogsBillable = "Timelogs_Billable",
    /** Projects License Flags **/
    projectsArchive = "Archive",
    projectsAutoArchive = "Archive_AutoArchive",
    crossProjectsDependencies = "CrossProjectsDependencies",
    aiForecast = "AIForecast",
    aiTasksGeneration = "AIWBS",
    /** Expenses License Flags **/
    expensesApproval = "Expenses_Approval",
    activityFinancialExpenses = "Expenses_Activity",
    /** Resources License Flags **/
    unnamedResources = "UnnamedResources",
    resourcesWorkload = "Resources_Workload",
    resourcesPlanning = "ResourcesPlanning",
    resourceWorkloadSchedule = "Resources_Schedule",
    whatIf = "WhatIf",
    /** Portfolios License Flags **/
    portfolios = "Portfolios",
    portfoliosNested = "Portfolios_Nested",
    portfoliosGroupBy = "Portfolios_GroupBy",
    /** Reports License Flags **/
    payroll = "Payroll",
    /** Company Settings License Flags **/
    colorCoding = "ColorCoding",
    securityPolicy = "SecurityPolicy",
    ssoSettings = "SSO",
    workflowsManagement = "Workflows_Management",
    /** Integration License Flags**/
    integrationJira = "Integration_Jira",
    integrationQuickbooks = "Integration_Quickbooks",
    /** Notifications License Flags**/
    notificationsStream = "Notifications_Stream",
    timeLocking = "Timelogs_Locking",
    invoices = "Invoices",
}

export enum LicenseFlagsNumber {
    snapshotsLimit = "Snapshots_Limit",
    teamsLimit = "Teams_Limit",
    guestUsersLimit = "GuestUsers_Limit",
}

export type LicenseFlags = {
    [key in LicenseFlagsBoolean]?: boolean;
} & {
    [key in LicenseFlagsNumber]?: number;
};

export interface LicenseFileType {
    LicenseFlags: LicenseFlags;
    LicenseType: LicenseTypes;
    LicensePlan: LicensePlans;
    Company: string;
    MaxUsersCount: number;
    ExpirationDate?: Date | string;
}
